import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const autoTrainingApi = {
  getAutoTraining: (request) => {
    // page_id
    // limit
    // search
    // offset
    const { config } = request
    return instance().get(`/training/cms/auto-training/conversation`, config)
  },
  getGptSuggest: (request) => {
    const { config, data } = request
    // page_id
    // "keyword":"test",
    // "language": "th"
    return instance().post(`/openai/cms/gpt-suggest`, data, config)
  },
  putUpdateDefaultChatlog: (request) => {
    const { config, data } = request
    // "page_id": "105387828535129",
    // "questiondata": [
    //     "asdyvjubfnu"
    // ],
    // "newintent": "test"
    return instance().put(`/training/cms/updatedefaultchatlogs`, data, config)
  },
  getNonClassifiedChatlog: (request) => {
    const { config } = request
    // page_id
    // search
    // limit
    // offset
    return instance().get(`/training/cms/non-classified`, config)
  }
}

export default autoTrainingApi



// WEBPACK FOOTER //
// ./src/api/auto-training.js